import type { IMasterDataPurchaserRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataPurchaserDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataPurchaserUseCase {
  private readonly repository: IMasterDataPurchaserRepository;

  constructor(repository: IMasterDataPurchaserRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataPurchaserDTO) {
    return this.repository.updatePurchaser(params);
  }
}
